import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { BlockComponent } from "@components/container-block/block.component";
import { HeaderComponent } from "@components/header/header.component";
import { InputComponent } from "@components/input/input.component";
import { TranslatePipe } from "@ngx-translate/core";
import { BusyService } from "~app/common/components/busy/busy.service";
import { DirtyFormService } from "~app/common/services/dirty-form.service";
import { DirtyTabComponent } from "~app/features/regelverk-viol/dirtyTabComponent";
import { ResponsePanelComponent } from "../../components/response-panel/response-panel.component";
import { SystemadministrationService } from "../../systemadministration.service";

@Component({
    selector: "rask-sysadm-prolog",
    templateUrl: "./sysadm-prolog.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HeaderComponent,
        BlockComponent,
        ResponsePanelComponent,
        InputComponent,
        FormsModule,
        ButtonComponent,
        TranslatePipe
    ]
})
export class SysadmPrologComponent extends DirtyTabComponent {
    lagerplatsId: string;
    result: number;

    private readonly administrationService = inject(SystemadministrationService);
    private readonly busyService = inject(BusyService);

    constructor() {
        const dirtyFormService = inject(DirtyFormService);

        super(dirtyFormService);
    }

    canSave() {
        // Tom, ingen användning här
    }

    isDirtyCheck(): boolean {
        return false;
    }

    restoreChanges() {
        // Tom, ingen användning här
    }

    saveChanges() {
        // Tom, ingen användning här
    }

    updateLagersaldo() {
        this.result = undefined;
        this.busyService.addWork(this.administrationService.updateLagersaldo(this.lagerplatsId))
            .subscribe((result: number) => {
                this.result = result;
            });
    }
}
